<template>
  <v-dialog v-model="dialog" width="650">
    <template v-slot:activator="{ on }">
      <v-btn rounded color="primary" class="ml-3" v-on="on" id="login_btn">
        <span class="mx-4">Login</span>
      </v-btn>
    </template>

    <v-card color="transparent">
      <v-layout row wrap justify-center fill-height ma-0>
        <v-flex xs12 sm5 class="bg-left white--text pa-0 pt-sm-10">
          <v-layout class="d-flex flex-xs-row flex-sm-column pa-5 pa-sm-10">
            <v-flex class="d-flex justify-center ">
              <img
                width="80"
                height="80"
                :src="require('../assets/images/logo/logo@3x.png')"
                class="my-auto ml-auto mr-2 mx-sm-auto"
              />
            </v-flex>
            <v-flex class="text-start text-sm-center">
              <p class="display-1 font-weight-bold mb-0 ml-auto mx-sm-auto mt-sm-5 mb-sm-3">
                TRAMS
              </p>
              <p
                class="subtitle-1 font-weight-regular mb-0 ml-auto mt-xs-auto mx-sm-auto"
                :class="{ 'subtitle-2': $vuetify.breakpoint.width <= 625 }"
              >
              ระบบรายงานข้อมูลอุบัติเหตุ<br />ของกระทรวงคมนาคม
              </p>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm7 class="bg-right d-flex justify-center pa-5 pa-sm-10">
          <v-layout row wrap ma-0 mx-5>
            <v-flex xs12 mt-1 mt-sm-10>
              <p class="display-1 secondary--text font-weight-bold text-center mt-0 mt-sm-10">
                Login
              </p>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                ref="usernameInput"
                hide-details
                v-model="username"
                prepend-inner-icon="person"
                @keyup.enter="$refs.passwordInput.focus()"
              >
              </v-text-field>
              <v-text-field
                ref="passwordInput"
                hide-details
                v-model="password"
                type="password"
                prepend-inner-icon="lock"
                @keyup.enter="login"
                class="mt-4"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 mb-0 mb-sm-10>
              <p v-if="error" class="red--text mt-4">{{ error }}</p>
              <v-btn rounded block color="primary" class="mt-4 mb-5 my-sm-10" @click="login">
                <span class="mx-4">Login</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
const qs = require('qs');

export default {
  name: 'Login',
  props: {
    loginResult: {
      type: Object
    }
  },
  data() {
    return {
      on: false,
      dialog: false,
      is_login: false,
      username: '',
      password: '',
      error: null
    };
  },
  mounted() {
    const username = localStorage.getItem('username');
    if (username) {
      this.username = username;
    }
  },
  methods: {
    login() {
      this.$emit('login', this.username, this.password);
    }
  },
  watch: {
    loginResult(val) {
      if (val.result) {
        this.dialog = false;
        this.error = null;
      } else {
        this.error = val.messages;
      }

      this.is_login = val.result;
    },
    error(val) {
      if (val == 'Network Error') {
        this.error = 'ไม่สามารถเชื่อมต่อกับระบบได้';
      } else if (val == 'Invalid username and password combination') {
        this.error = 'ชื่อหรือรหัสผ่านผู้ใช้ไม่ถูกต้อง';
      } else if (val == 'Parameter Required : username') {
        this.error = 'กรุณากรอกชื่อผู้ใช้';
      } else if (val == 'Parameter Required : password') {
        this.error = 'กรุณากรอกรหัสผ่าน';
      } else {
        this.error = val;
      }
      console.log(val);
    },
    dialog(val) {
      if (this.is_login) {
        this.dialog = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-left {
  background-color: rgba(81, 70, 72, 0.9);
}
.bg-right {
  background-color: rgba(255, 255, 255, 0.9);
}
</style>
